import { PROVIDER_FRACTION, SLOTS_IN_HOUR } from 'ziphy-web-shared/basic/entities/schedules';
export const DEFAULT_LAYERS = {
    appointment: true,
    travel: true,
    practice: true,
    office: false,
    shift: true,
};
export const CARD_HEIGHT = 37;
export const HOUR_HEIGHT = (CARD_HEIGHT + 5) * SLOTS_IN_HOUR;
export const EXTRA_SLOTS = 0;
export const MAX_COLUMN_WIDTH = 12;
export const WIDTH_BY_PROVIDER_FRACTION = Object.fromEntries(Object.entries(PROVIDER_FRACTION).map(([value, count]) => {
    return [value, MAX_COLUMN_WIDTH * (1 / count)];
}));
